export const CreditCardType = {
  "American Express": "American Express",
  Discover: "Discover",
  Visa: "Visa",
  MasterCard: "MasterCard",
  "Bank Account": "Bank Account",
  "Google Pay": "Google Pay",
  "Apple Pay": "Apple Pay",
} as const;

export type CreditCardType =
  (typeof CreditCardType)[keyof typeof CreditCardType];
